import { StopeDataDto, StopeLocationDto } from 'providers/api';
import { PCNode } from '../Nodes';
import PCStope from './PCStope';

const initStopes = (stopeLocations: StopeLocationDto[], stopes: StopeDataDto[], nodes: Record<string, PCNode>) => {
  const stopeObjs: Record<string, PCStope[]> = {};
  stopeLocations.forEach((stope) => {
    const stopeData = stopes.find((sl) => sl.stopeId === stope.stopeId);
    if (stopeData) {
      stopeObjs[stope.nodeId] ??= []; // Initialize the array if it doesn't exist
      stopeObjs[stope.nodeId].push(new PCStope(nodes[stope.nodeId], stopeData));
    }
  });

  return stopeObjs;
};

export default initStopes;
